import { Actions } from '@feature/citi-redirects/src/util/Constants';

module.exports = (App) => {
  const CitiAnalyticsTags = require('@feature/citi-redirects/src/mcom/analytics/TealiumTags')(App);
  App.channel.on(Actions.card.add, () => {
    CitiAnalyticsTags.card.onAddCard();
  });
};
